import React from "react";

const DashboardShape3 = () => {
	return (
		<svg width={709} height={1119} viewBox="0 0 709 1119" fill="none">
			<g filter="url(#filter0_f_31_334)">
				<path
					d="M453.978 796.77C584.514 854.719 737.129 795.466 794.855 664.426C852.581 533.386 793.559 380.179 663.021 322.23C532.487 264.281 379.871 323.533 322.145 454.574C264.418 585.614 323.442 738.821 453.978 796.77Z"
					fill="url(#paint0_radial_31_334)"
					fillOpacity="0.7"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_31_334"
					x={0}
					y={0}
					width={1117}
					height={1119}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={150}
						result="effect1_foregroundBlur_31_334"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_31_334"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(1059.95 877.093) rotate(-154.353) scale(1195.21 1087.96)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default DashboardShape3;
